module.exports = __webpack_public_path__ + "img/21.cd0636da.jpeg";